import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboardDown: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconKeyboardDown"><Path fillRule="evenodd" clipRule="evenodd" d="M1 2V16H23V2H1ZM9 12V10.5H15V12H9ZM6.5 10.5H5V12H6.5V10.5ZM5 6H6.5V7.5H5V6ZM10.5 6H9V7.5H10.5V6ZM13.5 6H15V7.5H13.5V6ZM19.0002 6H17.5002V7.5H19.0002V6ZM17.5 10.5H19V12H17.5V10.5Z" fill="currentColor"/><Path d="M12.0001 19.9395L10.0001 17.9395L8.93945 19.0001L12.0001 22.0608L15.0608 19.0001L14.0001 17.9395L12.0001 19.9395Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboardDown;
